import { gtmEventType, inquiryType } from '@Components/Utilities/SandhillsConstants';
import { useRef } from 'react';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import TranslationText from '@Components/Utilities/TranslationText';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';
import translator from '@Components/Utilities/Translator';

const FBODirectoryFuelTable = loadable(() => import('@Components/DealerDirectory/FBODirectoryFuelTable'));

const DealerDirectoryListing = (props) => {

    const ref = useRef();

    const openEmailModal = () => props.openEmailModal(inquiryType.Email, {
        DealerGroupID: props.DealerGroupID,
        DealerCRMID: props.DealerCRMID,
        BranchName: props.BranchName,
        Subject: props.EmailSubject,
        ref: ref
    });

    return (
        <div className={'dealer-directory-listing'}>
            <input type='hidden' name='LocationID' value={props.LocationID} />
            <div className='dealer-listing-row'>
                <div className='dealer-listing-half'>
                    {props.DealerLogoURL && <img src={props.DealerLogoURL} className='dealer-logo mobile' alt='' rel={props.IsFirst ? 'preload' : ''} loading={props.IsFirst ? '' : 'lazy'} />}
                    <div className='dealer-contact-info'>
                            <div>
                            <ConditionalWrapper condition={props.UseSEOHTagReorganization} wrapper={children => <h2 className="header-reset">{children}</h2>}>
                                {props.InventoryUrls && props.InventoryUrls.length > 0 && !props.IsCoopDirectory ?
                                    <strong><a href={props.InventoryUrls[0].Url} className='dealer-title-text'>{props.DealerName}</a></strong> :
                                    <strong><span className='dealer-title-text'>{props.DealerName}</span></strong>}
                                </ConditionalWrapper>
                            {props.InventoryManagementURL && <a href={props.InventoryManagementURL} className='dealer-data-text' target='_blank' aria-label={"View in Inventory Management (" + translator.translate('sandhills.opensinanewtab') + ")"}>View in Inventory Management</a>}
                            </div>
                                {props.ShowStreetAddress && <div className='dealer-data-text'>{props.DealerAddress}</div>}
                        <ConditionalWrapper condition={props.UseSEOHTagReorganization} wrapper={children => <h3 className="header-reset">{children}</h3>}>
                                    <div className='dealer-data-text'>{props.DealerCityStatePostal}</div>
                            </ConditionalWrapper>
                        <br />
                    </div>
                    {props.DistanceFrom && props.DistanceFrom !== '' &&
                        <div className='distance-away'>
                            <i className='fas fa-location-dot' /> {props.DistanceFrom}
                        </div>}
                </div>
                <div className='dealer-listing-half'>
                    {props.DealerLogoURL && <img src={props.DealerLogoURL} className='dealer-logo' alt='' rel={props.IsFirst ? 'preload' : ''} loading={props.IsFirst ? '' : 'lazy'} />}
                </div>
            </div>
            <div className='dealer-listing-row button-container'>
                {props.UnformattedDealerPhoneNumber && props.UnformattedDealerPhoneNumber !== '' &&
                    <a href={'tel:' + props.UnformattedDealerPhoneNumber} onClick={() => gtmPushEvent(gtmEventType.call)} className='dealer-contact-button btn--pub-reversed dealer-phone dealer-data-text'>
                        <i className='fas fa-phone-alt fa-flip-horizontal gtm-noclick' />
                        {props.FormattedDealerPhoneNumber}
                    </a>}
                {props.TextingEnabled &&
                    <a href={'sms:' + props.UnformattedDealerPhoneNumber} onClick={() => gtmPushEvent(gtmEventType.sms)} className='dealer-contact-button btn--pub-reversed dealer-phone dealer-data-text texting'>
                        <span className='text-icon' />
                        {props.FormattedDealerPhoneNumber}
                    </a>}
                {props.ShowEmailButton &&
                    <button ref={ref} key={props.LocationID} className='ts-button dealer-contact-button dealer-title-text des-email-seller send-email' onClick={() => openEmailModal()}>
                        <i className='far fa-envelope' />
                        <TranslationText tKey='sandhills.sendemail' />
                    </button>}
                {(props.ShowEmployeeOnlyInfo && props.CrmLink) &&
                    <a href={props.CrmLink} className="dealer-contact-button btn--pub-reversed" target="_blank" aria-label={"Edit in CRM (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                        Edit in CRM
                    </a>}
            </div>
            {props.InventoryUrls && props.InventoryUrls.length > 0 &&
                <div className='dealer-listing-row button-container'>
                    {props.InventoryUrls && props.InventoryUrls.length > 0 &&
                        props.InventoryUrls.map((item, index) => <a className={'inventory-button ' + item.CssClass} href={item.Url} >{item.DisplayText}</a>)}
                </div>}
            {props.AuctionUrls && props.AuctionUrls.length > 0 &&
                <div className='dealer-listing-row button-container'>
                    {props.AuctionUrls && props.AuctionUrls.length > 0 &&
                        props.AuctionUrls.map((item, index) => <a className={'inventory-button ' + item.CssClass} href={item.Url} >{item.DisplayText}</a>)}
                </div>}
            {props.LeaseUrls && props.LeaseUrls.length > 0 &&
                <div className='dealer-listing-row button-container'>
                    {props.LeaseUrls && props.LeaseUrls.length > 0 &&
                        props.LeaseUrls.map((item, index) => <a className={'inventory-button ' + item.CssClass} href={item.Url} >{item.DisplayText}</a>)}
                </div>}
        </div>
    );
};

export default DealerDirectoryListing;